import { render, staticRenderFns } from "./ListDetailV3.vue?vue&type=template&id=c53ef62e&scoped=true&"
import script from "./ListDetailV3.vue?vue&type=script&lang=ts&"
export * from "./ListDetailV3.vue?vue&type=script&lang=ts&"
import style0 from "./ListDetailV3.vue?vue&type=style&index=0&id=c53ef62e&lang=scss&scoped=true&"
import style1 from "./ListDetailV3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53ef62e",
  null
  
)

export default component.exports